import { HttpError } from 'src/shared/utils/HttpError';
import { logger } from 'src/shared/utils/logger';

interface ICustomFetchOptions extends RequestInit {
  cache?: RequestCache;
  cacheStrategy?: {
    cache?: RequestCache;
    revalidate?: number;
    tags?: string[];
  };
}

/**
 * Обёртка над fetch: бросает HttpError при статусе >= 400
 * и прокидывает cacheStrategy в опции Next.js (revalidate, tags).
 */
export const customFetch = async <TResponsePayload = unknown>(
  url: string,
  options?: ICustomFetchOptions,
): Promise<TResponsePayload> => {
  const response = await fetch(url, {
    ...options,
    next: {
      revalidate: options?.cacheStrategy?.revalidate,
      tags: options?.cacheStrategy?.tags,
    },
  });

  if (!response.ok) {
    let errorData: unknown;

    try {
      errorData = await response.json();
    } catch (error) {
      logger.error('Не удалось разобрать тело ответа с ошибкой', error);
    }

    throw new HttpError(response.status, response.statusText, errorData);
  }

  return response.json() as Promise<TResponsePayload>;
};
